import React, { useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import classNames from "classnames";
import style from "../styles/ng_detail.module.scss";
import goodsStyle from "./styles/goods.module.scss";
import FilterBar from '../../../components/Filters/FilterBar';
import Subgroups from "./components/Subgroups";
import GoodList from "./components/GoodsList";

const Goods = ({ isActive = false, availableFilters = [] }) => {
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  const filtersRef = useRef(null);
  const btnRef = useRef(null);
  const [searchParams] = useSearchParams();

  const activeFilterCount = (() => {
    let count = 0;
    if (searchParams.get('price_min')) count++;
    if (searchParams.get('price_max')) count++;
    if (searchParams.get('in_stock')) count++;
    const p = searchParams.get('param');
    if (p) count += p.split('|').length;
    return count;
  })();

  useEffect(() => {
    if (!isFiltersOpen) return;
    const handleClick = (e) => {
      if (
        filtersRef.current && !filtersRef.current.contains(e.target) &&
        btnRef.current && !btnRef.current.contains(e.target)
      ) {
        setIsFiltersOpen(false);
      }
    };
    const handleEsc = (e) => {
      if (e.key === 'Escape') setIsFiltersOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('keydown', handleEsc);
    };
  }, [isFiltersOpen]);

  const panelClasses = classNames({
    [style.tab__panel]: true,
    [style["tab__panel--active"]]: isActive,
  });

  return (
    <div className={panelClasses}>
      <div className={style.goodsContent}>
        <div className={goodsStyle.subgroupsRow}>
          <Subgroups />
          <div className={goodsStyle.extraBtnWrapper}>
            <button
              ref={btnRef}
              type="button"
              className={classNames(goodsStyle.subgroups__item, {
                [goodsStyle['subgroups__item--active']]: isFiltersOpen,
              })}
              onClick={() => setIsFiltersOpen((prev) => !prev)}
            >
              <span className={goodsStyle.subgroups__item_title}>
                Дополнительно
              </span>
              {activeFilterCount > 0 && (
                <span className={goodsStyle.filterBadge}>{activeFilterCount}</span>
              )}
            </button>
            {isFiltersOpen && (
              <div ref={filtersRef} className={goodsStyle.filtersDropdown}>
                <FilterBar availableFilters={availableFilters} />
              </div>
            )}
          </div>
        </div>

        <GoodList />
      </div>
    </div>
  );
};

export default Goods;
